import { Icon, IconProps } from "./Icon";

export function IconFireplace(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M24 0H0v5h24Zm-1 4H1V1h22Zm-1 19V6h-1v17h-2v-8.56A7.23 7.23 0 0 0 12 7a7.23 7.23 0 0 0-7 7.43V23H3V6H2v17H0v1h24v-1ZM6 14.44A6.23 6.23 0 0 1 12 8a6.24 6.24 0 0 1 6 6.43V23h-2a4.1 4.1 0 0 0 1-2.42c.2-2.27-1-3.31-2.06-4.23-1.22-1.06-2.18-1.9-1.07-4.62l-.93-.38c-1.38 3.38.07 4.64 1.35 5.76 1 .87 1.87 1.62 1.72 3.38C15.63 23 12.9 23 12.9 23a4.65 4.65 0 0 0 .1-1.73 6.23 6.23 0 0 0-1.2-2.82 3.06 3.06 0 0 1-.36-3.66l-.92-.41A4 4 0 0 0 11 19a5.36 5.36 0 0 1 1 2.39A1.44 1.44 0 0 1 10.57 23h-.14a1.4 1.4 0 0 1-.8-.22 3.82 3.82 0 0 1-1.44-2 3.76 3.76 0 0 1 .27-2.87l-.87-.5A4.73 4.73 0 0 0 7.23 21a4.83 4.83 0 0 0 1.17 2H6Z" />
    </Icon>
  );
}
